import { useState } from 'react'

import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { Input } from '@tribeplatform/react-ui-kit/Input'

import { getFieldIcon } from './utils'

export const FieldPicker = ({ fields, onChange, value }) => {
  const [query, setQuery] = useState('')

  return (
    <Dropdown>
      {value ? (
        <Dropdown.Button>
          {fields.find(field => field.accessor === value)?.Header}
        </Dropdown.Button>
      ) : (
        <Dropdown.Button>Add filter</Dropdown.Button>
      )}
      <Dropdown.Items>
        <div className="p-2">
          <Input
            onChange={e => setQuery(e.target.value)}
            placeholder="Search..."
          />
        </div>
        <div className="max-h-120 overflow-auto">
          {fields
            .filter(field => {
              if (!query) return true
              const name = field?.name || field?.Header || ''
              return name.toLowerCase().includes(query?.toLowerCase())
            })
            .map(field => (
              <Dropdown.Item
                key={field.accessor}
                onClick={() => {
                  onChange(field?.accessor)
                }}
                leadingIcon={getFieldIcon(field)}
              >
                {field.name || field.Header}
              </Dropdown.Item>
            ))}
        </div>
      </Dropdown.Items>
    </Dropdown>
  )
}
